"use strict";

exports.__esModule = true;
exports["default"] = exports.PlusIcon = exports.MinusIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _ramda = require("ramda");

var _animations = require("@qc-modules/animations");

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _elements = require("../glyphs/elements");

var _distributorList = _interopRequireDefault(require("./distributor-list"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MinusIcon = (0, _styledComponents["default"])(_elements.NavRemoveMinus).withConfig({
  displayName: "extra-info__MinusIcon",
  componentId: "sc-1ivhufz-0"
})(["fill:currentColor;"]);
exports.MinusIcon = MinusIcon;
var PlusIcon = (0, _styledComponents["default"])(_elements.NavAddPlus).withConfig({
  displayName: "extra-info__PlusIcon",
  componentId: "sc-1ivhufz-1"
})(["fill:currentColor;"]);
exports.PlusIcon = PlusIcon;
var OpenStatusIcon = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "extra-info__OpenStatusIcon",
  componentId: "sc-1ivhufz-2"
})(["cursor:pointer;border:1px solid ", ";border-radius:50%;color:", ";width:16px;height:16px;"], function (props) {
  return (0, _styles.colors)("blue", props);
}, function (props) {
  return (0, _styles.colors)("blue", props);
});
var Expando = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "extra-info__Expando",
  componentId: "sc-1ivhufz-3"
})(["overflow:hidden;"]);
var propTypes = {
  /** Array of objects containing distributors to download from */
  distributors: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    companies: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]).isRequired
    })),
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]).isRequired,
    region: _propTypes.string
  })),

  /** Boolean to determine if the expanded area is open or not */
  isOpen: _propTypes.bool,

  /** Node or string for the purchase button text  */
  purchaseText: _propTypes.node,

  /** onClick handler for result item container */
  resultItemOnClick: _propTypes.func
};

var ExtraInfo = function ExtraInfo(_ref) {
  var distributors = _ref.distributors,
      isOpen = _ref.isOpen,
      purchaseText = _ref.purchaseText,
      resultItemOnClick = _ref.resultItemOnClick;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    as: "section",
    flexWrap: "wrap"
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    justifyContent: "space-between",
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
    color: "blue",
    mb: isOpen ? 3 : 0,
    tag: "h1"
  }, purchaseText), /*#__PURE__*/_react["default"].createElement(OpenStatusIcon, {
    alignItems: "right",
    onClick: isOpen ? resultItemOnClick : null,
    width: [1 / 12]
  }, isOpen ? /*#__PURE__*/_react["default"].createElement(MinusIcon, {
    height: "100%",
    width: "100%"
  }) : /*#__PURE__*/_react["default"].createElement(PlusIcon, {
    height: "100%",
    width: "100%"
  }))), distributors && /*#__PURE__*/_react["default"].createElement(_animations.TransitionHeight, {
    alwaysShowInDom: true,
    enterDuration: 0.25,
    exitDuration: 0.2,
    fadeInOut: true,
    show: isOpen
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    display: "none",
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(Expando, {
    flexWrap: "wrap"
  }, (0, _ramda.map)(function (_ref2) {
    var companies = _ref2.companies,
        id = _ref2.id,
        region = _ref2.region;
    return /*#__PURE__*/_react["default"].createElement(_distributorList["default"], {
      key: id,
      companies: companies,
      region: region
    });
  }, distributors)))));
};

ExtraInfo.propTypes = propTypes;
var _default = ExtraInfo;
exports["default"] = _default;